import React from 'react'
import styled from '@emotion/styled'

import { AppBar, Toolbar } from '@mui/material'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import ExpanderToggle from '../Components/ExpanderToggle/ExpanderToggle'
import HideOnScroll from './HideOnScroll'
import { SearchBar, UserAvatar } from '../Components'

const FlexToolbar = styled(Toolbar)`
    display: flex;
    flex-direction: row;
`
const SearchBarContainer = styled.div`
    flex-grow: 1;
    padding: 5px 0px 5px 0px;
    margin-right: 15px;
`

const StyledAppBar = styled(AppBar)`
    background-color: ${({ theme }) => theme.palette.common.white} !important;
`

interface Props extends RouteComponentProps {
    auctionPickerOpenRequest: number
    searchText: string
    setSearchText: React.Dispatch<React.SetStateAction<string>>
    pathname: string
}

const MobileNav: React.FC<Props> = ({ auctionPickerOpenRequest, searchText, setSearchText }) => {
    const editing = false

    return (
        <div>
            <HideOnScroll>
                <StyledAppBar>
                    <FlexToolbar>
                        <ExpanderToggle />
                        <SearchBarContainer>
                            <SearchBar
                                searchText={searchText}
                                setSearchText={setSearchText}
                                mobile
                                disabled={editing}
                            />
                        </SearchBarContainer>
                        <UserAvatar auctionPickerOpenRequest={auctionPickerOpenRequest} disabled={editing} />
                    </FlexToolbar>
                </StyledAppBar>
            </HideOnScroll>
            {/* Empty Toolbars for spacing: https://material-ui.com/components/app-bar/#fixed-placement */}
            <Toolbar />
        </div>
    )
}

export default withRouter(MobileNav)
